// extracted by mini-css-extract-plugin
export var actionButton = "_gd-t";
export var buttonContainer = "_gd-0";
export var buttonContainer2 = "_gd-1";
export var buttonSection = "_gd-2";
export var details = "_gd-3";
export var dropdownItem = "_gd-5";
export var dropdownItemsContainer = "_gd-4";
export var fileInput = "_gd-r";
export var headerButton = "_gd-6";
export var icon = "_gd-7";
export var input = "_gd-8";
export var macroListItem = "_gd-9";
export var mainContent = "_gd-a";
export var microText = "_gd-b";
export var modal = "_gd-w";
export var optionsButton = "_gd-c";
export var paperclip = "_gd-s";
export var pillContent = "_gd-d";
export var preview = "_gd-e";
export var preview2 = "_gd-f";
export var quillEditor = "_gd-q";
export var selectedMacro = "_gd-g";
export var sidebar = "_gd-h";
export var sidebarHeader = "_gd-j";
export var sidebarList = "_gd-i";
export var sidebarListItem = "_gd-k";
export var sidebarSearch = "_gd-l";
export var snoozeDurationWrapper = "_gd-v";
export var statusPillContainer = "_gd-m";
export var tagsContainer = "_gd-n";
export var unselectedMacro = "_gd-o";
export var variable = "_gd-u";
export var wrapper = "_gd-p";